import { IdLang } from "./i18n/IdLang";
import { IdLoca } from "./i18n/IdLoca";
import { ReplacementLoca } from "./i18n/ReplacementLoca";
import { utilLoca } from "./i18n/utilLoca";
import { utilNumber } from "./utilNumber";
var UtilTime = /** @class */ (function () {
    function UtilTime() {
        var _this = this;
        this.now = Date.now;
        this.currentLanguage = utilLoca.getCurrentLanguage;
        this.language = IdLang.None;
        this.fullDateTimeOptions = {
            day: "2-digit",
            hour: "2-digit",
            hour12: false,
            minute: "2-digit",
            month: "2-digit",
            second: "2-digit",
            timeZone: "UTC",
            timeZoneName: "short",
            year: "numeric",
        };
        this.dateTimeOptions = {
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            month: "2-digit",
            year: "numeric",
        };
        this.dateOptions = {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        };
        this.timestamp = function (offset) {
            if (offset === void 0) { offset = 0; }
            return _this.now() + (offset || 0) * 1000;
        };
        this.timestampMs = function (offsetMs) {
            if (offsetMs === void 0) { offsetMs = 0; }
            return _this.now() + (offsetMs || 0);
        };
        this.remainingTimeToTimestamp = function (remainingSeconds) {
            var isAlreadyConverted = _this.isTimestamp(remainingSeconds || 0);
            if (isAlreadyConverted) {
                return remainingSeconds;
            }
            return remainingSeconds ? _this.timestamp(remainingSeconds) : undefined;
        };
        this.secondsLeftTill = function (timestamp) {
            return timestamp ? ((timestamp || 0) - _this.now()) / 1000 : 0;
        };
        this.secondsElapsedSince = function (timestamp) {
            return timestamp ? (_this.now() - (timestamp || 0)) / 1000 : 0;
        };
        this.secondsToMs = function (seconds) { return seconds * 1000; };
        this.msToSeconds = function (ms) { return ms / 1000; };
        this.timerProgress = function (current, max) {
            return utilNumber.clamp((current / max) * 100, 0, 100);
        };
        this.timerProgressReversed = function (current, max) {
            return utilNumber.clamp(100 - (current / max) * 100, 0, 100);
        };
        this.format = function (seconds) {
            var _a = UtilTime.getHoursMinutesAndSeconds(seconds), h = _a.h, m = _a.m, s = _a.s;
            return utilNumber.pad(h, 2) + ":" + utilNumber.pad(m, 2) + ":" + utilNumber.pad(s, 2);
        };
        this.secondsToTime = function (seconds) {
            var d = Math.floor(seconds / (3600 * 24));
            var _a = UtilTime.getHoursMinutesAndSeconds(seconds), h = _a.h, m = _a.m, s = _a.s;
            return { d: d, h: h, m: m, s: s };
        };
        this.formatSecondsToFormat = function (seconds, format, intlFormatString) {
            var currentLanguage = _this.currentLanguage();
            if (_this.language === IdLang.None || _this.language !== currentLanguage) {
                _this.language = currentLanguage;
                intlFormatString = undefined;
            }
            if (intlFormatString === undefined) {
                intlFormatString = new Intl.DateTimeFormat(_this.language, format).format;
            }
            return intlFormatString(seconds);
        };
        this.secondsToFullDateString = function (seconds) {
            return _this.formatSecondsToFormat(seconds, _this.fullDateTimeOptions, _this.intlSecondsToFullDateTimeString);
        };
        this.secondsToDateTimeString = function (seconds) {
            return _this.formatSecondsToFormat(seconds, _this.dateTimeOptions, _this.intlSecondsToDateTimeString);
        };
        this.secondsToDateString = function (seconds) {
            return _this.formatSecondsToFormat(seconds, _this.dateOptions, _this.intlSecondsToDateString);
        };
        this.secondsFromCreationDateToString = function (seconds) {
            var date = new Date(_this.now());
            date.setSeconds(date.getSeconds() - seconds);
            return _this.secondsToDateString(date.getTime());
        };
        this.getCreatedDateFromSeconds = function (seconds) {
            var date = new Date(_this.now());
            date.setSeconds(date.getSeconds() + seconds);
            return _this.secondsToDateTimeString(date.getTime());
        };
        this.ageFromCreationDate = function (timeStamp) {
            var secondsElapsed = _this.secondsElapsedSince(timeStamp * 1000);
            var _a = _this.secondsToTime(secondsElapsed), d = _a.d, h = _a.h, m = _a.m;
            if (d > 0) {
                return utilLoca.get(IdLoca.timeDisplay_xDays, new Map([[ReplacementLoca.zero_0, utilNumber.format(d)]]));
            }
            else if (h < 24 && h > 1) {
                return utilLoca.get(IdLoca.timeDisplay_xHours, new Map([[ReplacementLoca.zero_0, utilNumber.format(h)]]));
            }
            else {
                return utilLoca.get(IdLoca.timeDisplay_xMinutes, new Map([[ReplacementLoca.zero_0, utilNumber.format(m)]]));
            }
        };
        this.isDifferentDay = function (otherTimestamp) {
            if (!_this.isTimestamp(otherTimestamp)) {
                return true;
            }
            var currentDate = new Date(_this.now());
            var otherDate = new Date(otherTimestamp);
            var daysDiffer = currentDate.getDay() !== otherDate.getDay();
            var monthDiffer = currentDate.getMonth() !== otherDate.getMonth();
            var yearDiffer = currentDate.getFullYear() !== otherDate.getFullYear();
            return daysDiffer || monthDiffer || yearDiffer;
        };
        /**
         * Checks if value is timestamp by checking it against Jan 1 2018
         */
        this.isTimestamp = function (value) { return value >= 1514764800000; };
    }
    UtilTime.getHoursMinutesAndSeconds = function (seconds) {
        var h = Math.floor(seconds / 3600) % 24;
        var m = Math.floor(seconds / 60) % 60;
        var s = Math.floor(seconds % 60);
        return { h: h, m: m, s: s };
    };
    return UtilTime;
}());
export var utilTime = new UtilTime();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilTime.ts
// module id = 22
// module chunks = 3